// Swedish UI labels for case statuses
export const STATUS = {
  inkommet: { label: "Inkommet", classes: "bg-blue-50 text-blue-700 border-blue-200" },
  komplettering: { label: "Komplettering", classes: "bg-amber-50 text-amber-700 border-amber-200" },
  beslut: { label: "Beslut", classes: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  avslutat: { label: "Avslutat", classes: "bg-zinc-100 text-zinc-700 border-zinc-200" },
};

export const STATUS_LIST = ["inkommet", "komplettering", "beslut", "avslutat"];

export const CASE_TYPES = [
  "Nybyggnad",
  "Tillbyggnad",
  "Fasadändring",
  "Komplementbyggnad",
  "Ändrad användning",
  "Rivning",
  "Annat",
];

export const CONTACT_ROLES = ["sökande", "handläggare", "entreprenör"];

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("sv-SE", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("sv-SE", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "nyss";
  if (diff < 3600) return `${Math.floor(diff / 60)} min sedan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} tim sedan`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} d sedan`;
  return formatDate(iso);
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").slice(0, 2).map((s) => s[0]).join("").toUpperCase();
}
